import React, { useState } from 'react';
import { Modal, Header, Icon, Button } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
// import dashboardStore from './app/stores/dashboardStore';
import { useStore } from '../app/stores/store';
function UnauthorizedMessage() {
  const { dashboardStore } = useStore();
  const [open, setOpen] = useState(false);
  const history = useNavigate();
  useEffect(() => {
    setOpen(true);
  }, [dashboardStore.dashboard.selectedUserRoleId]);
  return (
    <div>
      <Modal basic open={open} size="small">
        <Header icon>
          <Icon name="lock" />
          Access Denied
        </Header>
        <Modal.Content>
          <p>
            Unfortunately, it appears that you are not authorised to view this
            information; please contact your administrator to have access
            granted to you.
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" inverted onClick={() => history(-1)}>
            Back
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
}

export default UnauthorizedMessage;
